import { renderPageShell } from '../lib/page-shell';
import { resetPassword } from '../lib/session';
import type { RouteHandler } from '../lib/router';

export const renderResetPassword: RouteHandler = (container, navigate, query) => {
  const token = query.get('token');

  const body = renderPageShell(container, navigate, 'account', {
    title: 'RESET PASSWORD',
    subtitle: 'Choose a new password.',
    body: token
      ? `
        <form class="choice-card" id="reset-form" aria-labelledby="reset-heading">
          <strong id="reset-heading">New password</strong>
          <input class="join-input" name="password" type="password" placeholder="New password (min 8 chars)" aria-label="New password" autocomplete="new-password" required />
          <button class="button button--primary" type="submit">Set new password</button>
          <p class="form-error" data-role="status" aria-live="polite"></p>
        </form>
      `
      : `<p class="settings-hint">This link is missing its token. Use the link from your email exactly as sent.</p>`,
  });

  const form = body.querySelector<HTMLFormElement>('#reset-form');
  if (!form || !token) return;
  const status = form.querySelector<HTMLParagraphElement>('[data-role="status"]')!;

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const password = String(new FormData(form).get('password'));
    const submitButton = form.querySelector<HTMLButtonElement>('button[type="submit"]')!;
    submitButton.disabled = true;
    try {
      await resetPassword(token, password);
      form.innerHTML = `
        <p>Password updated. You've been signed out everywhere, including here.</p>
        <button class="button button--primary" type="button" data-action="login">Log in</button>
      `;
      form.querySelector<HTMLButtonElement>('[data-action="login"]')?.addEventListener('click', () => navigate('account'));
    } catch (error) {
      status.textContent = error instanceof Error ? error.message : 'That reset link is invalid or has expired.';
      submitButton.disabled = false;
    }
  });
};
